// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3bc17765","185":"b9bcfa86","481":"ed758535","667":"084ab817","863":"e55aeb48"}[chunkId] + ".chunk.js";
};